<template>
  <div class="header">
    <page-breadcrumbs :breadcrumbs="breadcrumbs" v-if="breadcrumbs" />

    <div class="header-layout">
      <div class="info-container">
        <div class="icon-container" v-if="icon">
          <img class="icon" :src="icon" />
        </div>
        <div class="avatar-container" v-else-if="avatar">
          <el-avatar :size="64" :src="avatar"></el-avatar>
        </div>
        <div class="title-description-container">
          <div class="title-container">
            <span class="title">
              {{ title }}
            </span>
            <div class="tag" v-if="tag">
              <el-tag :type="tag.type" :class="tag.class" size="mini">
                {{ tag.label }}
              </el-tag>
            </div>
            <div v-if="tags" class="tags-section">
              <div class="tag" v-for="(tagEl, index) in tags" :key="index">
                <el-tag
                  :class="tagEl.class"
                  :type="tagEl.type"
                  size="mini"
                  :effect="tagEl.effect"
                >
                  {{ tagEl.label }}
                </el-tag>
              </div>
            </div>
            <el-badge
              v-if="badge"
              :class="badge.class || ''"
              :type="badge.type || 'success'"
              is-dot
            />
          </div>
          <span v-if="description" class="description">
            {{ description }}
          </span>

          <div v-if="meta" class="sub-header">
            <div v-for="(item, index) in meta" :key="index">
              <router-link :to="item.route" v-if="item.route && item.label">
                <i v-if="item.icon" :class="item.icon"></i>
                {{ item.label }}
              </router-link>
              <span v-else-if="item.label">
                <i v-if="item.icon" :class="item.icon"></i>
                {{ item.label }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="actions">
        <slot name="actions" />
      </div>
    </div>

    <slot name="content" />
  </div>
</template>

<script>
import PageBreadcrumbs from '@/common/components/page/PageBreadcrumbs'

export default {
  name: 'PageHeaderNew',

  components: { PageBreadcrumbs },

  props: {
    breadcrumbs: {
      type: Array,
      required: false
    },

    title: {
      type: String,
      required: true
    },

    description: {
      type: String,
      required: false
    },

    icon: {
      required: false
    },

    avatar: {
      required: false
    },

    tag: {
      type: Object,
      required: false
    },

    tags: {
      type: Array,
      default: () => []
    },

    badge: {
      type: Object,
      required: false
    },

    meta: {
      type: Array,
      required: false
    }
  }
}
</script>

<style scoped>
.header {
  background: #f2f5f9;
  border-bottom: 1px solid #e5e5e5;
  padding-top: 16px;
}

.header-layout {
  margin: 0 auto;
  padding: 0 20px 16px 20px;
  display: flex;
  justify-content: space-between;
}

.info-container {
  display: flex;
  align-items: center;
  min-height: 36px;
}

.icon-container {
  height: 64px;
  width: 64px;
  background-color: #ffffff;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.icon {
  max-width: 90%;
  max-height: 100%;
}

.avatar-container {
  height: 64px;
  width: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.title-description-container {
  display: flex;
  flex-direction: column;
}

.title-container {
  display: flex;
  align-items: center;
}

.title {
  color: #333333;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
}

.description {
  color: #808080;
  font-size: 12px;
  line-height: 18px;
}

.tag {
  margin-left: 14px;
}

.actions {
  display: flex;
  align-items: center;
}

>>> .actions .el-button {
  min-width: 120px;
}

>>> .actions > * {
  margin-left: 10px;
}

.sub-header {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  color: #7e8596;
}

.sub-header a {
  color: #7e8596;
}

.sub-header > div {
  margin-right: 25px;
  margin-top: 15px;
}

.sub-header > div > span > i {
  margin-right: 5px;
}

.tags-section {
  display: flex;
  gap: 10px;
  margin-left: 14px;
}

.tags-section .tag {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/common/components/page/PageHeaderNew.vue